// Emblème Papicoo — géométrie reprise à l'identique du logo SVG de papicoo.fr (aucune création nouvelle)
const aperture = ((cx, cy, r1, r2, twist) => {
  const hex = [];
  const blades = [];
  for (let o = 0; o < 6; o++) {
    const a = -Math.PI / 2 + o * (2 * Math.PI / 6);
    hex.push([cx + r1 * Math.cos(a), cy + r1 * Math.sin(a)]);
  }
  for (let o = 0; o < 6; o++) {
    const a = -Math.PI / 2 + o * (2 * Math.PI / 6);
    blades.push([[cx + r1 * Math.cos(a), cy + r1 * Math.sin(a)], [cx + r2 * Math.cos(a + twist), cy + r2 * Math.sin(a + twist)]]);
  }
  return { hexPath: "M" + hex.map((p) => p.map((v) => v.toFixed(2)).join(",")).join(" L") + " Z", blades };
})(50, 50, 21, 39, (2 * Math.PI / 6) * 0.62);

const TOWER = [
  "M45.5 46 C46.5 39 48 33.5 50 29", "M54.5 46 C53.5 39 52 33.5 50 29",
  "M42 57.5 C43.2 53 44.4 49.6 45.5 46", "M58 57.5 C56.8 53 55.6 49.6 54.5 46",
  "M36 70 C37.6 65.4 39.6 61.2 42 57.5", "M64 70 C62.4 65.4 60.4 61.2 58 57.5",
  "M44.5 70 C45.5 66 47 62.4 49 58.4", "M55.5 70 C54.5 66 53 62.4 51 58.4", "M42 66.5 Q50 60.5 58 66.5",
];
const TOWER_LINES = [[50, 22, 50, 29], [45, 46, 55, 46], [41, 57.5, 59, 57.5], [35, 70, 45.5, 70], [54.5, 70, 65, 70]];

export function BrandMark({ className = "w-7 h-7" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
      <circle cx="50" cy="50" r="48" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.85" />
      {aperture.blades.map(([a, b], i) => (
        <line key={i} x1={a[0]} y1={a[1]} x2={b[0]} y2={b[1]} stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.4" />
      ))}
      <path d={aperture.hexPath} fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" opacity="0.85" />
      <g fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
        {TOWER_LINES.map(([x1, y1, x2, y2], i) => <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />)}
        {TOWER.map((d) => <path key={d} d={d} />)}
      </g>
    </svg>
  );
}

// Lockup du header papicoo.fr : emblème safran qui pivote de 180° au survol (700 ms), désactivé si mouvements réduits
export function BrandLockup({ withBaseline = true, baseline }) {
  return (
    <>
      <span className="text-[color:var(--papicoo-gold)] transition-transform duration-700 motion-safe:group-hover:rotate-180 motion-safe:group-focus-visible:rotate-180">
        <BrandMark className="w-7 h-7" />
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-display font-semibold text-xl tracking-tight uppercase text-white">Papicoo</span>
        {withBaseline && <span className="hidden sm:block text-[9px] tracking-[0.32em] uppercase text-white/50 mt-1">{baseline}</span>}
      </span>
    </>
  );
}
